const Config = {
  _config: {},

  fromObject( o ) {
    this._config = o;
  },

  getConfig() {
    return this._config;
  },

  getProperty( k, defval ) {
    if ( this._config.hasOwnProperty( k ) ) {
      return this._config[ k ];
    } else {
      return defval;
    }
  }
}

export default Config;


// WEBPACK FOOTER //
// ./src/utils/config.js